export const BACKUP_TABLES: string[] = [];

export async function backupToCloudflareD1(progressCallback?: (msg: string) => void): Promise<void> {
  if (progressCallback) progressCallback('Cloudflare D1 backup is disabled.');
  console.log('Cloudflare D1 backup is disabled.');
}

export async function checkAndAutoBackupOnLogin(): Promise<void> {
  console.log('Cloudflare D1 backup is disabled.');
}
